import { LegacyTask } from '../task/legacy-task.model';
import { WorkflowTaskWorkflow } from 'ng2-app/modules/task-management/models/workflow-task/workflow-task-workflow.class';

export class WorkflowTask extends LegacyTask {
    tasks: WorkflowTaskWorkflow[];
    role: 'fundingDesk' | 'fundingManager';
}
